<template>
    <div class="final-container">
        <div class="info-top">
            <p class="title">Your profile is now public</p>
            <p class="desc">Venues can view it and invite you to gig directly</p>
        </div>
        <div class="links">
            <a class="profile-link" :href="`/artists/${userData.socialInfo.slug}`">
                View My Profile
            </a>
            <a class="opportunity-link" href="/opportunities">Explore Opportunities</a>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Final',
        props: {
            userData: {
                type: Object,
                required: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .final-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 24px;

        .info-top {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
        }
        .links {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 15px;

            .profile-link,
            .opportunity-link {
                max-width: 188px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px 16px;
                border-radius: 120px;
                border: 1px solid #cdeb09;
                color: #cdeb09;
                @include base-font-14;
                line-height: 115%;
                letter-spacing: 0.14px;
                text-decoration: none;
                text-wrap: nowrap;
            }
        }
    }
</style>
